import { FC, memo } from 'react';

import LoadingPlaceholder from '../LoadingPlaceholder';

const WalletSkeletonComponent: FC = () => {
  return <LoadingPlaceholder height="32px" width="100px" />;
};

export const WalletSkeleton = memo(WalletSkeletonComponent);
